import { Form, Formik } from 'formik';
import { useContext, useEffect, useRef, useState } from 'react';
import { APISource } from '../../../../../../../../typings/Source.interface';
import { cleanseFormErrorObject } from '../../../../../utils/form';
import Button from '../../../../common/base/Button';
import { Div } from '../../../../common/helpers/StyledUtils';
import { useToasts } from '../../../../common/Toast';
import { GlobalContext } from '../../../../contexts/GlobalContext';
import resource_details_form_props from '../../Connections/Forms/resource_details';
import configuration_form_props, { SourceConfigurationFormValues } from '../../Connections/Forms/source_configuration';
import { DashboardContext } from '../../DashboardContext';
const AddSource: React.FC<{
  context: {
    source: APISource | null;
  };
  mutateContext: (any) => void;
  nextStep: () => void;
}> = ({
  context: {
    source
  },
  mutateContext,
  nextStep
}) => {
  const {
    HookdeckAPI
  } = useContext(GlobalContext);
  const {
    source_types
  } = useContext(DashboardContext);
  const {
    addToast
  } = useToasts();
  const [render_key, setRenderKey] = useState(1);
  const previous_source_id = useRef<string | null>(source?.id ?? null);
  const show_advanced_ref = useRef(false);
  useEffect(() => {
    if (source && previous_source_id.current === source.id) {
      setRenderKey(prev => prev + 1);
    }
    previous_source_id.current = source?.id ?? null;
  }, [source?.config.allowed_http_methods, source?.config.auth]);
  return <Formik key={render_key} initialValues={{
    ...resource_details_form_props.getInitialValues(source || undefined),
    ...configuration_form_props.getInitialValues(source || undefined, {
      in_guided_connection: true
    }),
    show_advanced: show_advanced_ref.current
  }} validateOnMount validate={async values => cleanseFormErrorObject({
    ...(await resource_details_form_props.validate(values, name => source && name === source.name ? Promise.resolve(false) : HookdeckAPI.sources.nameIsUsed(name), true)),
    ...(await configuration_form_props.validate(values as SourceConfigurationFormValues, source_types!))
  })} onSubmit={(v, {
    resetForm
  }) => {
    const values_0 = {
      ...resource_details_form_props.postprocessValues(v),
      ...configuration_form_props.postprocessValues(v as SourceConfigurationFormValues, source_types)
    };
    const promise = source ? HookdeckAPI.sources.update(source.id, values_0) : HookdeckAPI.sources.create(values_0);
    return promise.then(new_source => {
      mutateContext({
        source: new_source
      });
      resetForm({
        values: {
          ...v,
          ...resource_details_form_props.getInitialValues(new_source || undefined),
          ...configuration_form_props.getInitialValues(new_source || undefined, {
            in_guided_connection: true
          }),
          show_advanced: v.show_advanced
        }
      });
      if (source) {
        addToast('success', `Source ${new_source.name} configuration updated`);
      }
      nextStep();
    }).catch(e => {
      addToast('error', `An error occurred while saving the source${e.response?.data[0] ? `: ${e.response.data[0]}` : ''}`);
      return;
    });
  }}>
      {({
      isValid,
      isSubmitting,
      handleSubmit,
      dirty,
      values: values_1
    }) => {
      show_advanced_ref.current = (values_1 as SourceConfigurationFormValues).show_advanced;
      return <Form data-testid="guided-add-source-form" onSubmit={handleSubmit}>
            <Div m={{
          t: 0
        }}>
              <configuration_form_props.Fields prefix="" hide_optional_features in_guided_connection />
            </Div>
            <Div flex={{
          gap: 3
        }} m={{
          t: 6
        }}>
              <Button submit disabled={!isValid || isSubmitting || !!source && !dirty} primary={!source} outline={!!source} icon={isSubmitting ? 'loading' : undefined}>
                {source ? 'Update' : 'Next'}
              </Button>
            </Div>
          </Form>;
    }}
    </Formik>;
};
export default AddSource;